import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa31ff26"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "demo-modal__bg fixed inset-0 z-50 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_2 = { class: "fixed inset-0 z-50 w-screen overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center sm:p-0" }
const _hoisted_4 = { class: "bg-white px-4 pb-4 pt-5 sm:p-6" }
const _hoisted_5 = { class: "absolute right-0 top-0 block pr-4 pt-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1))
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "text-base font-semibold leading-6 text-gray-900 pb-3 pr-6 border-b border-gray-200",
  id: "modal-title"
}, "Request a demo", -1))
const _hoisted_9 = { class: "mt-5" }
const _hoisted_10 = {
  ref: "iframeEl",
  src: "https://genprox.pipedrive.com/scheduler/KkRaMRIR/demo-fundequate",
  title: "Request a demo",
  class: "w-full demo-modal__iframe",
  frameborder: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XMark = _resolveComponent("XMark")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    "enter-active-class": "ease-out duration-300",
    "enter-class": "opacity-0",
    "enter-to-class": "opacity-100",
    "leave-active-class": "ease-in duration-200",
    "leave-class": "opacity-100",
    "leave-to-class": "opacity-0",
    onAfterEnter: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showContent = true)),
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "demo-modal relative z-50",
        "aria-labelledby": "modal-title",
        role: "dialog",
        "aria-modal": "true",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode("\\ "),
            _createVNode(_Transition, {
              name: "fade",
              "enter-active-class": "ease-out duration-300",
              "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
              "leave-active-class": "ease-in duration-500",
              "leave-class": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              appear: ""
            }, {
              default: _withCtx(() => [
                (_ctx.showContent)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                      class: "relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 demo-modal__container"
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                            class: "rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2"
                          }, [
                            _hoisted_6,
                            _createVNode(_component_XMark, { class: "h-6 w-6" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("iframe", _hoisted_10, null, 512)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 1
            })
          ])
        ])
      ])
    ], undefined, true),
    _: 1
  }))
}